import { CartActionArg, ServerCartPayload } from "src/types/cart/CartItem";
import apiSlice from "../apiSlice";


// Every cart mutation returns the full canonical cart, so the response *is* the
// post-mutation server state. Writing it straight into the `getCart` cache keeps
// that cache authoritative without spending an extra round trip per tap, which
// `invalidatesTags` would cost on every quantity change.
const seedGetCartCache = async (
    _arg: unknown,
    { dispatch, queryFulfilled }: { dispatch: (action: unknown) => unknown; queryFulfilled: Promise<{ data: ServerCartPayload }> },
) => {
    try {
        const { data } = await queryFulfilled;
        dispatch(cartApiSlice.util.upsertQueryData("getCart", undefined, data));
    } catch {
        // A failed mutation leaves the cached cart untouched; the next
        // mount/focus refetch reconciles it.
    }
};

const cartApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // Canonical authenticated cart — the same `serialize_cart` payload the
        // mobile app reads from /api/mobile/carts/. No business logic is
        // duplicated client-side.
        getCart: build.query<ServerCartPayload, void>({
            query: () => "/carts/",
            providesTags: ["Cart"],
        }),
        cartSync: build.mutation<ServerCartPayload, { slug: string; qty: number }[]>({
            query: (items) => ({
                url: "/carts/sync/",
                method: "POST",
                body: { items },
            }),
            onQueryStarted: seedGetCartCache,
        }),
        cartAction: build.mutation<ServerCartPayload, CartActionArg>({
            query: (action) => ({
                url: "/carts/action/",
                method: "POST",
                body: action,
            }),
            onQueryStarted: seedGetCartCache,
        }),
    }),
});


export const { useGetCartQuery, useLazyGetCartQuery, useCartSyncMutation, useCartActionMutation } = cartApiSlice;

export default cartApiSlice;
